
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/api/graph/graph.zh.md?watch=parent';
    export const toc = [{"id":"配置","depth":2,"title":"配置"}];
export const frontmatter = {"title":"画布","toc":"menu","filename":"docs/api/graph/graph.zh.md","lastUpdated":1753191685000,"order":0,"redirect_from":["/zh/docs","/zh/docs/api","/zh/docs/api/graph"]};